export interface UrlRankRequest {
  keyword: string;
  product_url: string;
  /** true면 오늘 저장 순위를 무시하고 다시 조회 */
  force_refresh?: boolean;
}

export type UrlRankCheckStatus =
  | 'stored_complete'
  | 'pending'
  | 'running'
  | 'complete'
  | 'partial'
  | 'failed';

/** POST 202 — 조회 작업 수락 */
export interface UrlRankJobAccepted {
  job_id: string;
  rank_check_status: 'pending' | 'running';
  rank: null;
  search_range?: number;
  status_url?: string;
}

/** 조회 완료/진행 결과 */
export interface UrlRankResult {
  keyword?: string;
  product_url?: string;
  rank: number | null;
  nv_mid?: string | null;
  rank_check_status: UrlRankCheckStatus;
  search_range?: number;
  source?: string;
  organic_only?: boolean;
  rank_date?: string;
  rank_basis?: string;
  job_id?: string;
  status_url?: string;
  checked_products?: number;
  checked_rank?: number;
  elapsed_ms?: number;
  created_at?: string | null;
  completed_at?: string | null;
  error?: string | null;
  message?: string;
}

export type UrlRankLookupOutcome =
  | { kind: 'stored'; result: UrlRankResult }
  | { kind: 'accepted'; job: UrlRankJobAccepted; seed?: UrlRankResult };

export interface UrlRankError {
  type: 'VALIDATION_ERROR' | 'API_ERROR';
  message: string;
  details?: string;
}

export const URL_RANK_POLL_INTERVAL_MS = 3_000;
/** 480위 조회는 수 분이 걸릴 수 있음 */
export const URL_RANK_POLL_MAX_MS = 10 * 60_000;

export function isUrlRankTerminalStatus(
  status: UrlRankCheckStatus | undefined,
): boolean {
  return (
    status === 'stored_complete' ||
    status === 'complete' ||
    status === 'partial' ||
    status === 'failed'
  );
}

export function isUrlRankPendingStatus(
  status: UrlRankCheckStatus | undefined,
): boolean {
  return status === 'pending' || status === 'running';
}
